import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  phone: "",
  email: "",
  loading: false,
  error: false,
};
const bestContactInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BEST_CONTACT_INFO:
      return updateObject(state, { ...action.bestContactInfo });
      case actionTypes.RESET_FETCH_BEST_CONTACT_INFO:
        return initialState;
    default:
      return state;
  }
};

export default bestContactInfoReducer;
